export const appConfig = {
    classes: {
        hidden: "u-hidden"
    }
};
